export function record(value) {
  return typeof value === "object" && value !== null;
}
export function banners(value) {
  if (!record(value) || !Array.isArray(value.data)) throw new Error("Invalid banner response");
  return value.data.map(item => {
    if (!record(item) || typeof item.id !== "string" || item.type !== "banners" || !record(item.attributes)) throw new Error("Invalid banner");
    const a = item.attributes;
    if (!["image", "html"].includes(String(a.type)) || !["none", "internal", "external"].includes(String(a.linkType)) || !["imageUrl", "targetUrl", "href", "html"].every(key => a[key] === null || typeof a[key] === "string") || !["priority", "clickCount", "impressionCount"].every(key => typeof a[key] === "number" && Number.isSafeInteger(a[key]) && Number(a[key]) >= 0) || !["enabled", "openNewTab", "isSponsored"].every(key => typeof a[key] === "boolean") || !(a.pageId === null || typeof a.pageId === "number" && Number.isSafeInteger(a.pageId) && a.pageId > 0)) throw new Error("Invalid attributes");
    return item;
  });
}
export function pages(value) {
  if (!record(value) || !Array.isArray(value.data)) throw new Error("Invalid pages response");
  return value.data.map(item => {
    if (!record(item) || typeof item.id !== "number" || !Number.isSafeInteger(item.id) || item.id < 1 || typeof item.title !== "string" || typeof item.path !== "string" || typeof item.hidden !== "boolean") throw new Error("Invalid page");
    return item;
  });
}
flarum.reg.add('xgay-banner', 'common/types', { record: record,banners: banners,pages: pages, });